module.exports = __webpack_public_path__ + "static/media/maintenance-right@3x.a6cdc61f.png";